import { isInputLikeElement } from '@src/utils/dom/inputElement';

/**
 * App コンポーネント用ヘルパー関数
 */

/**
 * タブクローズ時の警告設定
 *
 * @param {boolean} doAlert - 警告を表示するかどうか
 * @returns {void}
 */
export const onTabClose = (doAlert: boolean): (() => void) => {
  const handler = (event: WindowEventHandlersEventMap['beforeunload']) => {
    if (doAlert) {
      event.preventDefault();
      // Chrome requires returnValue to be set.
      event.returnValue = '';
    }
  };

  window.addEventListener('beforeunload', handler);

  return () => {
    window.removeEventListener('beforeunload', handler);
  };
};

/**
 * 最適化されたタイピング監視（デバウンス機能付き）
 *
 * @param {() => void} onTyping - タイピング検出時のコールバック関数
 * @returns {() => void} クリーンアップ関数
 */
export const setupTypingWatcher = (onTyping: () => void): (() => void) => {
  let timeoutId: NodeJS.Timeout | null = null;

  // ナビゲーションキーとして除外するキーのリスト
  const ignoredKeys = new Set([
    'ArrowUp',
    'ArrowDown',
    'ArrowLeft',
    'ArrowRight',
    'Tab',
    'Escape',
    'Enter',
    'Shift',
    'Control',
    'Alt',
    'Meta',
    'CapsLock',
    'PageUp',
    'PageDown',
    'Home',
    'End',
    'F1',
    'F2',
    'F3',
    'F4',
    'F5',
    'F6',
    'F7',
    'F8',
    'F9',
    'F10',
    'F11',
    'F12',
  ]);

  const handleTyping = (event: KeyboardEvent): void => {
    // ナビゲーションキーの場合は無視
    if (ignoredKeys.has(event.key)) {
      return;
    }

    // フォーム要素以外でのキー入力は無視
    if (!isInputLikeElement(event.target)) {
      return;
    }

    if (timeoutId) {
      clearTimeout(timeoutId);
    }

    timeoutId = setTimeout(() => {
      onTyping();
      timeoutId = null;
    }, 500); // 500msデバウンス
  };

  document.addEventListener('keydown', handleTyping);

  // クリーンアップ関数を返す
  return (): void => {
    if (timeoutId) {
      clearTimeout(timeoutId);
    }
    document.removeEventListener('keydown', handleTyping);
  };
};
